module.exports = __webpack_public_path__ + "media/top/sub_catchcopy-d9fcd188.svg";